import { ERROR_CODE_400, ERROR_CODE_401, ERROR_CODE_404, ERROR_CODE_500 } from "manifest-bridge-core/src/errors";
import {
  TRANSFER_STATUS_PENDING,
  TRANSFER_STATUS_COMPLETED,
  TRANSFER_STATUS_INPROGRESS,
} from "manifest-bridge-core/src/transferStatus";

export type ErrorCode = typeof ERROR_CODE_400 | typeof ERROR_CODE_401 | typeof ERROR_CODE_404 | typeof ERROR_CODE_500;
export type ClientTransferStatus =
  | typeof TRANSFER_STATUS_PENDING
  | typeof TRANSFER_STATUS_COMPLETED
  | typeof TRANSFER_STATUS_INPROGRESS;
export type TransferData = {
  transferIntentId: string;
  transferId: string[] | number[];
  userId?: string | null;
};

export const BRIDGE_DEVELOPMENT = "BRIDGE_DEVELOPMENT";
export const BRIDGE_PRODUCTION = "BRIDGE_PRODUCTION";
export const BRIDGE_DEMO = "BRIDGE_DEMO";
export type BridgeEnv = typeof BRIDGE_DEVELOPMENT | typeof BRIDGE_PRODUCTION | typeof BRIDGE_DEMO;

export type CloseParams = {
  transferIntentStatus: ClientTransferStatus;
  transferData: TransferData;
};

export type ErrorParams = {
  errorCode: ErrorCode;
  errorMessage: string;
};

export const UNEXPECTED_ERROR_MESSAGE = "An unexpected error occurred";
export const UNAUTHORIZED_ERROR_MESSAGE = "Invalid token";

export {
  ERROR_CODE_400,
  ERROR_CODE_401,
  ERROR_CODE_404,
  ERROR_CODE_500,
  TRANSFER_STATUS_PENDING,
  TRANSFER_STATUS_COMPLETED,
};
